<form [formGroup]="formGroup">
  <div class="auth-container p-2">
    <div class="login-box">
      <div class="surface-card p-4 shadow-2 border-round-2xl w-full">

        <div class="flex justify-content-center">
          <div class="text-center mb-5 mt-3">
            <img src="../../../../assets/images/logo_klaus_light_blue.svg"
                 class="w-10rem" alt="logo" (click)="navigateToLogin()">
          </div>
        </div>

        <div class="text-center mb-4">
          <div class="text-color text-3xl font-semibold mb-2">E-Mail eingeben</div>
          <span class="text-600 font-medium line-height-3 text-color-secondary">Trag deine E-Mail-Adresse ein und erhalte dein Einmalpasswort zur Anmeldung.</span>
        </div>

        <div class="mb-3 flex flex-column gap-3">
          <div class="mb-2">
            <label for="emailForget" class="block text-900 font-medium mb-2">E-Mail-Adresse</label>
            <input id="emailForget" type="email" pInputText formControlName="email"
                   class="w-full" placeholder="E-Mail eingeben">
          </div>
          <p-message
            severity="error"
            text="Bitte gib eine gültige E-mail-Adresse ein."
            *ngIf="formGroup?.get('email')?.invalid && showValidation">
          </p-message>
        </div>

        <app-button
          [type]="'submit'"
          [busy]="busy"
          [label]="'Einmalpasswort senden'"
          [class]="'w-full my-2'"
          (click)="handleStepComplete()">
        </app-button>
        <div class="flex justify-content-center">
          <app-button
            [label]="'Andere Option wählen'"
            [class]="'p-button-text mt-2'"
            [showIcon]="true"
            [iconPos]="'left'"
            [icon]="'pi pi-arrow-left'"
            (onClick)="navigateBack()">
          </app-button>
        </div>
      </div>
    </div>
  </div>
</form>
